import { Directive, HostListener, Inject } from '@angular/core';
import { Executable } from '../executable';
import { UntilDestroy } from '@ngneat/until-destroy';
import { UpdateBuildingExecutableService } from './update-building-executable.service';

/**
 * Represents a directive that handles the export functionality.
 */
@UntilDestroy()
@Directive({
  selector: '[spUpdateBuilding]',
  standalone: false,
})
export class UpdateBuildingExecutableDirective implements Executable {
  constructor(@Inject(UpdateBuildingExecutableService) private updateBuildingService: Executable) {}
  /**
   * Uses provided service to Open the export dialog. On close and if the user clicked on export, it
   * requests to get the exported data with the selected configuration
   */
  @HostListener('click', ['$event'])
  execute = (): void => this.updateBuildingService.execute();
}
